<div [formGroup]="form"
     class="component-container">
  <div class="ui-g form-rows">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
      <label class="ui-g-5 field-label text-right-align"
             for="base-data-water-pipe-material">
        {{'facilities-data.form-fields.water-pipe-material' | translate}}</label>
      <p-dropdown [options]="waterFormOptions.pipeMaterialOptions"
                  [readonly]="isReadOnly"
                  formControlName="waterPipeMaterial"
                  id="base-data-water-pipe-material"
                  placeholder="-Select-">
        <ng-template let-selectedPipeMaterial
                     pTemplate="selectedItem">
          <span class="drop-item-label"> {{ selectedPipeMaterial?.label}} </span>
        </ng-template>

        <ng-template let-option
                     pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label"> {{option.label}} </span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <div class="ui-g form-rows">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
      <label class="ui-g-5 field-label text-right-align"
             for="base-data-water-installation-type">
        {{'facilities-data.form-fields.water-installation-type' | translate}}</label>
      <p-dropdown [options]="waterFormOptions.installationTypeOptions"
                  [readonly]="isReadOnly"
                  formControlName="waterInstallationType"
                  id="base-data-water-installation-type"
                  placeholder="-Select-">
        <ng-template let-selectedInstallationType
                     pTemplate="selectedItem">
          <span class="drop-item-label"> {{ selectedInstallationType?.label}} </span>
        </ng-template>

        <ng-template let-option
                     pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label"> {{option.label}} </span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <div class="ui-g form-rows">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
      <label class="ui-g-5 field-label text-right-align"
             for="base-data-water-reflux-fuse">
        {{'facilities-data.form-fields.water-reflux-fuse' | translate}}</label>
      <p-dropdown [options]="waterFormOptions.refluxFuseOptions"
                  [readonly]="isReadOnly"
                  formControlName="waterRefluxFuse"
                  id="base-data-water-reflux-fuse"
                  placeholder="-Select-">
        <ng-template let-selectedRefluxFuse
                     pTemplate="selectedItem">
          <span class="drop-item-label"> {{ selectedRefluxFuse?.label}} </span>
        </ng-template>

        <ng-template let-option
                     pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label"> {{option.label}} </span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div class="ui-g form-rows">
    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding checkbox-bottom-padding">
      <label class="ui-g-5 field-label text-right-align"
             for="base-data-water-devices">
        {{'facilities-data.form-fields.water-devices' | translate}}</label>
      <p-dropdown [options]="waterFormOptions.devicesOptions"
                  [readonly]="isReadOnly"
                  formControlName="waterDevices"
                  id="base-data-water-devices"
                  placeholder="-Select-">
        <ng-template let-selectedDevice
                     pTemplate="selectedItem">
          <span class="drop-item-label"> {{ selectedDevice?.label}} </span>
        </ng-template>

        <ng-template let-option
                     pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label"> {{option.label}} </span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

</div>
